/**
 * TransformationInsight — json-render adapter wrapping real TransformationInsightCard
 *
 * Transforms semantic catalog props into TransformationInsightCard props.
 * Catalog (LLM-friendly) -> Registry (adapter) -> Real RN Component
 *
 * Prop mapping:
 *   title        -> transformationType
 *   before       -> beforeText
 *   after        -> afterText
 *   rationale    -> insights (split at sentence boundaries, max 3)
 *   category     -> (not used by real component directly)
 *   impactScore  -> impactScore
 *   tierLevel    -> forced to 3 (tier enforcement is upstream via injectTierGuards)
 *
 * [DRAMAX ONLY] — tier enforcement handled by injectTierGuards() upstream.
 *
 * Task: [#1158.SDUI-M.P3.4a]
 * Agent: Diego <diego@liftping.net>
 */
"use client";

import React from "react";
import { TransformationInsightCard } from "../../components/TransformationInsightCard";
import type { TransformationInsightProps } from "../schema";

function rationaleToInsights(rationale: string): string[] {
  const sentences = rationale
    .split(/(?<=[.!?])\s+/)
    .map((s) => s.trim())
    .filter(Boolean)
    .slice(0, 3);
  return sentences.length > 0 ? sentences : [rationale];
}

export function TransformationInsight({
  title,
  before,
  after,
  rationale,
  category: _category,
  impactScore,
}: TransformationInsightProps) {
  const insights = rationaleToInsights(rationale);

  return (
    <TransformationInsightCard
      transformationType={title}
      beforeText={before}
      afterText={after}
      insights={insights}
      impactScore={impactScore}
      tierLevel={3}
    />
  );
}
